import { useSelector } from "react-redux";

import { useModuleMenuActions } from "store/ModuleMenuSlice";

const useModuleMenu = () => {
  const { loadModuleMenu } = useModuleMenuActions();

  const { moduleMenu } = useSelector((state) => state.ModuleMenuSlice);

  return {
    moduleMenu,
    loadModuleMenu,
  };
};

export default useModuleMenu;
